import NameTranslationMapper from "../../core/service/translations/NameTranslationMapper";
import { formatBooleanValue } from "../../util";
import OrganisationIndexCategory from "../model/OrganisationIndexCategory";

const OrganisationIndexCategoryMapper = (item: any) => {
  let organisationIndexCategory = OrganisationIndexCategory(item);
  organisationIndexCategory.valid = formatBooleanValue(item.valid);
  organisationIndexCategory.nameTranslations = (
    item.nameTranslations || []
  ).map((elem) => NameTranslationMapper(elem));
  return organisationIndexCategory;
};

export default OrganisationIndexCategoryMapper;
